import styled from 'styled-components'
import { device } from '../responsive'

export const Container = styled.div`
    padding: 5rem 0rem;
    max-width: 1200px;
    margin: auto;

    @media screen and ${device.xsmobile} {
        padding: 2rem 0rem 1rem;
    }
`
export const Title = styled.h2`
    text-align: center;
    font-size: 29px;
    font-weight: 600;
    margin-bottom: 1rem;
    text-transform: uppercase;
    @media screen and ${device.mobile} {
        font-size: 20px;  
    }
`
export const Hr = styled.div`
    margin: auto;
    width: 40px;
    height: 3px;
    background-color: #30B0B0;
    margin-bottom: 50px;

    @media screen and ${device.mobile} {
        margin-bottom: 40px;
    }
`
export const Wrapper = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 380px);
    grid-gap: 5px;
    margin: 20px 0px;
    padding: 10px 0px;
    

    @media screen and ${device.tablet} {
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(2, 300px); 
        
    } 
    @media screen and ${device.mobile} {
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(2, 290px); 
        grid-gap: 20px;
        margin-bottom: 40px;
        padding: 2rem 0rem 1rem;
        
    } 
    @media screen and ${device.xsmobile} {
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(2, 270px); 
        grid-gap: 20px;
        margin-bottom: 40px;
        
    }
`
export const Circle = styled.div`
    @media screen and ${device.tablet} {
        position: absolute;
        width: 350px;
        height: 350px;
        border-radius: 50%;
        background: rgba(245,245,245,0.7);
        z-index: -1;
        top: 0%;
        left: 50%;
        transform: translate(-50%)
    }
    @media screen and ${device.mobile} {
        width: 320px;
        height: 320px;
    }

    @media screen and ${device.xsmobile} {
        width: 290px;
        height: 290px;
    }
`

export const Filter = styled.ul`
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 50px 0;

    @media screen and ${device.mobile} {
        padding-bottom: 0px;
    }
   
`
export const FilterBtn = styled.li`
    width: 120px;
    text-align: center;
    padding: 8px 17px;
    margin: 3px;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    border-right: 1px solid #000000;
    

    &:nth-child(3) {
        border: none;
    }

    &:hover {
        color: teal;
    }

    @media screen and ${device.mobile} {
        font-size: 13px;
        padding: 6px 3px;
        
    }
    
`

export const GridImage = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const Image = styled.img`
    width: 420px;
    height: auto;

    @media screen and ${device.tablet} {
        width: 350px;
    } 

    @media screen and ${device.mobile} {
        width: 300px;
    } 
`
export const GridInfo = styled.div`
    align-self: center;
    margin-left: 30px;  

    @media screen and ${device.tablet} {
        text-align: center;
        margin-left: 0px;
    } 
`
export const Text = styled.h3`
    font-size: 27px;
    font-weight: 400;
    margin-top: 0px;
    margin-bottom: 0px;
    

    @media screen and ${device.tablet} {
        font-size: 28px;
        margin-bottom: 15px;
    } 
    @media screen and ${device.xsmobile} {
        font-size: 20px;
    }
`
export const Desc = styled.p`
    font-size: 18px;
    width: 80%;
    font-weight: 400;
    margin: 10px 0px 20px;
    


    @media screen and ${device.tablet} {
        margin: 10px auto 20px;
        font-size: 17px;
    } 
    @media screen and ${device.xsmobile} {
        font-size: 15px;
    }
`
export const Tools = styled.div`
    margin-bottom: 1.6rem;

    @media screen and ${device.tablet} {
        margin-bottom: 2.7rem;
        
    } 

    
`
export const Tool = styled.div`
    display: flex;
    align-items: center;
    font-weight: 500;   
    font-size: 1rem;
    margin-bottom: 0.3rem;

    @media screen and ${device.tablet} {
        justify-content: center;
        
    } 
    @media screen and ${device.mobile} {
        font-size: 0.9rem;
    } 
`

export const GridButtons = styled.div`
    margin-top: 30px;
`
export const GreenButton = styled.a`
transition: all 0.3s ease-in-out;
    border: none;
    background: teal;
    color: #2F2E41;
    font-size: 17px;
    padding: 10px 40px;
    font-weight: 500;
    width: 130px;
    border-radius: 15px;
    cursor: pointer;
    text-decoration: none;
    color: #ffffff;

    &:hover {
        background-color: #5BA5A5;
    }
    @media screen and ${device.tablet} {
        
        font-size: 16px;
        padding: 10px 30px;
        // width: 150;
    } 

    @media screen and ${device.xsmobile} {
        
        font-size: 13px;
    }
`
export const BlackButton = styled.a`
    transition: all 0.3s ease-in-out;
    border: none;
    background: #2F2E41;
    font-size: 17px;
    padding: 10px 40px;
    font-weight: 500;
    width: 130px;
    border-radius: 15px;
    cursor: pointer;
    text-decoration: none;
    color: #ffffff;
    margin-right: 15px;

    &:hover {
        background-color: #49485F;
    }
    @media screen and ${device.tablet} {
        
        font-size: 16px;
        padding: 10px 30px;
    } 

    @media screen and ${device.xsmobile} {
       
        font-size: 13px;
    }
`
